export default class EntryField {
	constructor(container) {
		this.element = container.querySelector(
			'.entry_field__element:not([type="checkbox"]):not([type="radio"])'
		);
		this.label = container.querySelector('.entry_field__label');
		this.error = container.querySelector('.entry_field__error');
		this.apply_button = container.querySelector('.entry_field__apply-button');
		this.discount = container.querySelector('.entry_field__discount');
		this.dimension = container.querySelector('.entry_field__dimension');

		this.clearButton = container.querySelector('.entry_field__clear-button');

		const element = this.element;
		if (this.clearButton) {
			this.clearButton.addEventListener('click', function(event) {
				event.preventDefault();

				element.value = '';
				element.dispatchEvent(new Event('input'));
				element.dispatchEvent(new Event('blur'));

				if (element.geo_point.directions) {
					element.form.dispatchEvent(new CustomEvent('distance_updated'));
				}
			});
		}

		const passwordVisibilityButton =
			container.querySelector('.entry_field__visibility-button');

		// Password visibility button functionality
		if (passwordVisibilityButton) {
			passwordVisibilityButton.addEventListener('click', function(event) {
				event.preventDefault();

				const is_active = passwordVisibilityButton.classList
					.contains('entry_field__visibility-button--active');

				element.type = is_active ? 'password' : 'text';

				passwordVisibilityButton.classList
					.toggle('entry_field__visibility-button--active');
			});
		}

		if (!this.element) return;

		this.element.entry_field = this;

		if (this.element.matches('[type="number"]')) {
			this.element.addEventListener('input', event => {
				const new_value = event.data;
				const regexp = /\d+(\.|,)?\d*/;

				if (regexp.test(this.element.value) || !new_value) {
					this.element.prev_value = this.element.value;
				} else {
					this.element.value = this.element.prev_value;
				}
			});

			this.element.addEventListener('paste', event => {
				const
					new_value = event.clipboardData.getData('text/plain'),
					regexp = /\d+\.?\d*/;

				if (!regexp.test(new_value)) event.preventDefault();
			});
		}

		this.toggleElementFilledStatus();
		this.element.addEventListener('input', () => {
			this.toggleElementFilledStatus();
		});

		this.element.addEventListener('blur', () => {
			this.clearErrors();
		});

		if (this.element.telInput) {
			container
				.querySelectorAll('.entry_field__label, .entry_field__error')
				.forEach(part => this.element.closest('.iti').appendChild(part));
		}

		this.element.dispatchEvent(new Event('input'));
	}

	clearErrors() {
		this.element.classList.remove('entry_field__element--invalid');
	}

	toggleElementFilledStatus() {
		const toggle = !!this.element.value || this.element.validity.badInput;

		this.element.classList.toggle('entry_field__element--filled', toggle);
		if (this.dimension) this.updateSuffix();
	}

	updateSuffix() {
		let width = this.getTextWidth(this.element.value, '16px Inter');
		if (width > this.element.clientWidth - 60 && this.element.clientWidth > 0) {
			width = this.element.clientWidth - 60;
		}

		this.dimension.style.left = 35 + width + 'px';
	}

	getTextWidth(text, font) {
	// re-use canvas object for better performance
		let canvas =
			this.getTextWidth.canvas ||
				(this.getTextWidth.canvas = document.createElement('canvas'));
		let context = canvas.getContext('2d');
		context.font = font;
		const metrics = context.measureText(text);
		return metrics.width;
	}
}
